// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"40d6d7f8","400":"40d6d7f8","773":"40d6d7f8","934":"40d6d7f8","964":"40d6d7f8"}[chunkId] + ".chunk.css";
};